import { useTranslation } from 'react-i18next';
import { PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { IBenefitDetail } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { benefitIconMapper } from '@/common/utils/benefits/benefit-utils';
import { LearningCentreModal } from '@/web/components/LearningCentreModal/LearningCentreModal';
import { SucFringeLCContent } from '@/web/containers/Benefits/ItalyBenefitsPage/components/LearningCenter/SucFringe/SucFringeLCContent';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { ExampleStep } from './Example/ExampleStep';
import { FringeLCContent } from './Fringe/FringeLCContent';
import { ProductStep } from './Product/ProductStep';
import { ProductsStep } from './Products/ProductsStep';

interface IProps {
  benefit: IBenefitDetail<IMenhirBenefitSlug>;
  toggleLearningCentre: any;
}

export function LearningCenter({ benefit, toggleLearningCentre }: IProps) {
  const { t } = useTranslation();
  const { company } = useEmployeeDetails();

  const determineTitle = () => {
    if (
      benefit.slug === 'fringe' &&
      company.settings.plan === PLAN.ITALY_FRINGE
    ) {
      return t(`learning_centre.italy-fringe.${benefit.slug}.title`);
    }
    return t(`learning_centre.${benefit.slug}.title`);
  };

  const determineSubtitle = () => {
    if (
      benefit.slug === 'fringe' &&
      company.settings.plan === PLAN.ITALY_FRINGE
    ) {
      return `learning_centre.italy-fringe.${benefit.slug}.subtitle`;
    }
    return `learning_centre.${benefit.slug}.subtitle`;
  };

  const determineLearningCenter = () => {
    if (benefit.slug === 'recreation' || benefit.slug === 'pension-funds') {
      return [<ProductStep benefit={benefit} key="product_step" />];
    }
    if (
      company.settings.plan === PLAN.ITALY_FRINGE &&
      benefit.slug === 'fringe'
    ) {
      return [
        <SucFringeLCContent
          benefit={benefit}
          key="suc_fringe_learning_center"
        />,
      ];
    }
    if (benefit.slug === 'fringe') {
      return [
        <FringeLCContent benefit={benefit} key="fringe_learning_center" />,
      ];
    }
    if (
      benefit.slug === 'family-care-services' ||
      benefit.slug === 'it-education' ||
      benefit.slug === 'it-transportation'
    ) {
      return [
        <ExampleStep benefit={benefit} key="example_step" />,
        <ProductsStep benefit={benefit} key="product_step" />,
      ];
    }
    return [];
  };

  return (
    <LearningCentreModal
      title={determineTitle()}
      subtitle={t(determineSubtitle(), {
        amount: MoneyUtils.moneyToString(benefit.usage?.limit),
      })}
      icon={benefitIconMapper[benefit.slug]}
      steps={determineLearningCenter()}
      onClose={() => toggleLearningCentre(false)}
    />
  );
}
